import { Modal } from "antd"
import { SystemDescriptions } from "src/common/descriptions"
import { User } from "src/common/models/user"
import { PasswordResetForm } from "./PasswordResetForm"
import { UpdatePasswordRequest } from "../state/types"
import { useDispatch, useSelector } from "react-redux"
import { updateUserPasswordApi } from "../state/action"
import { RootState } from "src/state/reducer"
import { useEffect } from "react"

interface Props {
    user: User
    open: boolean
    onAccept: VoidFunction
    onCancel: VoidFunction
}

interface ReduxProps {
    userResetPasswordSuccess: boolean
}

export const PasswordReset = (props: Props) => {
    const dispatch = useDispatch()

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        userResetPasswordSuccess: state.user.updatetUserPasswordSuccess,
    }))

    const commonDescriptions = SystemDescriptions.PAGES.COMMON

    useEffect(() => {
        if (reduxProps.userResetPasswordSuccess) {
            props.onAccept()
        }
    }, [reduxProps.userResetPasswordSuccess])

    const onFinish = (request: UpdatePasswordRequest) => {
        dispatch(updateUserPasswordApi(request))
    }

    return (
        <Modal
            title={'Reset Password'}
            centered
            open={props.open}
            onCancel={() => props.onCancel()}
            width={500}
            onOk={props.onAccept}
            okText={commonDescriptions.SAVE}
            cancelText={commonDescriptions.CANCEL}
            footer={<></>}
            closable={false}
            zIndex={1200}
            getContainer={false}
        >
            <PasswordResetForm
                onFinish={onFinish}
                onCancel={props.onCancel}
                user={props.user}
            />
        </Modal>
    )
}
